import { useNavigate, useLocation } from 'react-router-dom';

interface NavigateOptions {
  keepParams?: boolean;
  extraParams?: Record<string, string>;
  removeParams?: string[];
}

type NavigateWithParams = (to: string, options?: NavigateOptions) => void;

const useNavigateWithParams = (): NavigateWithParams => {
  const navigate = useNavigate();
  const location = useLocation();

  const navigateWithParams: NavigateWithParams = (to, options = {}) => {
    const { keepParams = true, extraParams = {}, removeParams = [] } = options;

    const currentParams = new URLSearchParams(location.search);

    if (!keepParams) {
      currentParams.forEach((_, key) => currentParams.delete(key));
    } else {
      removeParams.forEach((param) => currentParams.delete(param));
    }

    Object.entries(extraParams).forEach(([key, value]) => {
      currentParams.set(key, value);
    });

    const newSearch = currentParams.toString();
    const newPath = newSearch ? `${to}?${newSearch}` : to;

    navigate(newPath);
  };

  return navigateWithParams;
};

export default useNavigateWithParams;
